export default __webpack_public_path__ + "static/media/UR_Solomon.2ec09f58.png";